 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTML01_HALF_TIT from '@/components/html/01_Half_Tit'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML02_TITLE_PA from '@/components/html/02_Title_Pa'
 import HTML03_COPYRIGH from '@/components/html/03_Copyrigh'
 import HTML04_DEDICATI from '@/components/html/04_Dedicati'
 import HTML05_CONTENTS from '@/components/html/05_Contents'
 import HTML06_INTRODUC from '@/components/html/06_Introduc'
 import HTML07_1_GROWIN from '@/components/html/07_1_Growin'
 import HTML08_2_MATURI from '@/components/html/08_2_Maturi'
 import HTML09_3_BECOMI from '@/components/html/09_3_Becomi'
 import HTML10_4_BEYOND from '@/components/html/10_4_Beyond'
 import HTML11_5_ENGLAN from '@/components/html/11_5_Englan'
 import HTML12_6_HILDE from '@/components/html/12_6_Hilde'
 import HTML13_7_CORNEL from '@/components/html/13_7_Cornel'
 import HTML14_8_THE_HA from '@/components/html/14_8_The_Ha'
 import HTML15_9_ROSE_E from '@/components/html/15_9_Rose_E'
 import HTML16_CONCLUSI from '@/components/html/16_Conclusi'
 import HTML17_APPENDIX from '@/components/html/17_Appendix'
 import HTML18_A__THE_B from '@/components/html/18_A__The_B'
 import HTML19_B__COURS from '@/components/html/19_B__Cours'
 import HTML20_C__A_BRI from '@/components/html/20_C__A_Bri'
 import HTML21_D__COURS from '@/components/html/21_D__Cours'
 import HTML22_E__BETHE from '@/components/html/22_E__Bethe'
 import HTML23_F__THE_H from '@/components/html/23_F__The_H'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML24_NOTES from '@/components/html/24_Notes'
 import HTML25_REFERENC from '@/components/html/25_Referenc'
 import HTML26_ACKNOWLE from '@/components/html/26_Acknowle'
 import HTML27_INDEX from '@/components/html/27_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/05_Contents",
 			"name" : "html/05_Contents",
 			"component" : HTML05_CONTENTS
 		},
 		{
 			"path" : "/html/06_Introduc",
 			"name" : "html/06_Introduc",
 			"component" : HTML06_INTRODUC
 		},
 		{
 			"path" : "/html/07_1_Growin",
 			"name" : "html/07_1_Growin",
 			"component" : HTML07_1_GROWIN
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js